<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group v-model="Promo.promoTargetItem.target.targetType" style="width: 100%">
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-radio :label="formradio.value" class="mt-2">{{ formradio.label }}</el-radio>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row type="flex" justify="space-between" style="flex-wrap: wrap">
                  <template v-for="(form, idx) in formradio.form">
                    <el-col :span="form.span" style="margin-bottom: 18px" :key="idx">
                      <el-input
                        v-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
                        v-model="Promo.promoTargetItem.target[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formradio.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetItem.target[form.id]"
                        :multiple="form.multiple"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                        :disabled="disabledField(formradio.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                        <el-row type="flex" justify="center">
                          <el-button
                            :loading="form.onLoading"
                            size="mini"
                            round
                            @click="form.loadMore"
                          >Load More</el-button>
                        </el-row>
                      </el-select>
                    </el-col>
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["Promo"],
  data() {
    return {
      limitCategory: 25,
      limitBrand: 25,
      limitPrincipal: 25,
      limitProduct: 25
    };
  },
  computed: {
    ...mapState({
      categories: state => state.category.categories,
      brands: state => state.brand.brands,
      principals: state => state.principal.principals,
      products: state => state.product.products
    }),
    formRadio() {
      return [
        {
          label: "Oracle Item ID",
          value: "item",
          form: [
            {
              type: "select",
              id: "item",
              label: "",
              rules: [],
              multiple: true,
              data: this.products.data.map(item => {
                item.name = item.itemName;
                item.value = item.itemCode;
                return item;
              }),
              loadMore: this.loadMoreProduct,
              onSearch: this.onSearchProduct,
              onLoading: this.products.isLoading
            }
          ]
        },
        {
          label: "Category",
          value: "kategori",
          form: [
            {
              type: "select",
              id: "kategori",
              label: "",
              rules: [],
              multiple: true,
              data: this.categories.data.map(item => {
                item.name = item.categoryName;
                item.value = item.id.toString();
                return item;
              }),
              loadMore: this.loadMoreCategory,
              onSearch: this.onSearchCategory,
              onLoading: this.categories.isLoading
            }
          ]
        },
        {
          label: "Brand",
          value: "brand",
          form: [
            {
              type: "select",
              id: "brand",
              label: "",
              rules: [],
              data: this.brands.data.map(item => {
                item.name = `${item.brandCode} - ${item.brandName}`;
                item.value = item.id;
                return item;
              }),
              loadMore: this.loadMoreBrand,
              onSearch: this.onSearchBrand,
              onLoading: this.brands.isLoading
            }
          ]
        },
        {
          label: "Principal",
          value: "principal",
          form: [
            {
              type: "select",
              id: "principal",
              label: "",
              rules: [],
              data: this.principals.data.map(item => {
                item.name = `${item.principalCode} - ${item.principalName}`;
                item.value = item.id;
                return item;
              }),
              loadMore: this.loadMorePrincipal,
              onSearch: this.onSearchPrincipal,
              onLoading: this.principals.isLoading
            }
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getCategory: "category/GetCategorys",
      getBrand: "brand/GetBrands",
      getPrincipal: "principal/GetPrincipals",
      getProducts: "product/GetProducts",
    }),
    disabledField(value) {
      return this.Promo.promoTargetItem.target.targetType !== value
    },
    onSearchCategory(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getCategory({...option, ...option.params.kategoriLevel = 3});
    },
    loadMoreCategory() {
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory,
        }
      };
      this.getCategory({...option, ...option.params.kategoriLevel = 3});
    },
    onSearchBrand(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBrand(option);
    },
    loadMoreBrand() {
      this.limitBrand += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBrand,
        }
      };
      this.getBrand(option);
    },
    onSearchPrincipal(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getPrincipal(option);
    },
    loadMorePrincipal() {
      this.limitPrincipal += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitPrincipal,
        }
      };
      this.getPrincipal(option);
    },
    onSearchProduct(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getProducts(option);
    },
    loadMoreProduct() {
      this.limitProduct += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitProduct,
        }
      };
      this.getProducts(option);
    },
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getCategory({...option, ...option.params.kategoriLevel = 3});
    this.getBrand(option);
    this.getPrincipal(option);
    this.getProducts(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
